export const portalForSiteContractors = {
    slug: 'portal-for-site-contractors',
    no: '07',
    type: 'external',
    title: 'Portal For Site Contractors',
    category: 'UX Design',
    sourceUrl: 'https://himanshutanty.com/portfolio/portal-for-site-contractors/',
    cover: '/api/files/298826b8-2c74-4792-b75f-08f4dfb76789',
    external: {
        label: 'View Project on Behance',
        href: 'https://www.behance.net/gallery/166949415/Portal-For-Site-Contractors',
    },
    next: { slug: 'web-template', title: 'Individual Development Plan' },
};
